// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1Okrz","insightsList":"newBusinessInsightsMenu_insightsList__15ETa","active":"newBusinessInsightsMenu_active__1sdx1"};